import React from "react";
import PropTypes from "prop-types";
import styled from 'styled-components';

import { FormattedHTMLMessage } from 'react-intl';

export default class mehrfamilienhausDIN extends React.Component {
    render() {
        return(
<Wrapper>
    <OneRow>
        <TextField>
            <FormattedHTMLMessage id="Mehrfamilien_DIN_TextBlock_1" />
        </TextField>    
    </OneRow>
    <OneRow>
        <TextField>
            <FormattedHTMLMessage id="Mehrfamilien_DIN_TextBlock_2" />
        </TextField>  
    </OneRow>  
    <OneRow>
        <TextField>
            <FormattedHTMLMessage id="Mehrfamilien_DIN_TextBlock_3" />
        </TextField>  
    </OneRow>  

</Wrapper>
);
    }
}
const OneRow = styled.div`
clear:left;
`;
const Wrapper = styled.div`
font-family:GROTESK Regular;
font-size:15px;
line-height:20px;
font-weight:100;
`;


const TextField = styled.div`

width:95%;
color:black;
font-size:15px;
line-height:20px;
padding:2%;
`;